/**
 * WebSocket client for real-time notifications.
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

class ArchonWebSocket {
  constructor() {
    this.ws = null;
    this.listeners = {};
    this.reconnectTimer = null;
    this.reconnectAttempts = 0;
    this.maxReconnect = 5;
  }

  connect(token) {
    if (this.ws?.readyState === WebSocket.OPEN) return;

    const wsUrl = BACKEND_URL.replace("https://", "wss://").replace("http://", "ws://");
    this.ws = new WebSocket(`${wsUrl}/api/ws/${token}`);

    this.ws.onopen = () => {
      this.reconnectAttempts = 0;
      this._emit("connected", {});
    };

    this.ws.onmessage = (event) => {
      try {
        const message = JSON.parse(event.data);
        this._emit(message.event, message.data);
        this._emit("message", message);
      } catch { /* ignore */ }
    };

    this.ws.onclose = () => {
      this._emit("disconnected", {});
      this._scheduleReconnect(token);
    };

    this.ws.onerror = () => {
      this._emit("error", {});
    };
  }

  disconnect() {
    clearTimeout(this.reconnectTimer);
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }

  _scheduleReconnect(token) {
    if (this.reconnectAttempts >= this.maxReconnect) return;
    this.reconnectAttempts++;
    const delay = Math.min(1000 * Math.pow(2, this.reconnectAttempts), 30000);
    this.reconnectTimer = setTimeout(() => this.connect(token), delay);
  }

  on(event, callback) {
    if (!this.listeners[event]) this.listeners[event] = [];
    this.listeners[event].push(callback);
    return () => {
      this.listeners[event] = this.listeners[event].filter((cb) => cb !== callback);
    };
  }

  _emit(event, data) {
    (this.listeners[event] || []).forEach((cb) => {
      try { cb(data); } catch { /* ignore */ }
    });
  }
}

const archonWS = new ArchonWebSocket();
export default archonWS;
